import { LOAD_EVENT_SNAPSHOT } from './actionTypes';
import { getRegistrationPathId } from './selectors/currentRegistrationPath';
import setJSONValue from 'nucleus-widgets/utils/fields/setJSONValue';
import { getMergedRoommateSettings } from 'event-widgets/utils/travelUtils';
import getJSONValue from 'nucleus-widgets/utils/fields/getJSONValue';
import * as currentRegistrant from './selectors/currentRegistrant';

export const UPDATE_ROOMMATE_SETTINGS = 'event-guestside-site/appData/UPDATE_ROOMMATE_SETTINGS';

function mergeRegistrationSettings(existingRegistrationSettings = {}, newRegistrationSettings) {
  return {
    ...existingRegistrationSettings,
    ...newRegistrationSettings,
    registrationPaths: {
      ...existingRegistrationSettings.registrationPaths,
      ...newRegistrationSettings.registrationPaths
    },
    registrationQuestions: {
      ...existingRegistrationSettings.registrationQuestions,
      ...newRegistrationSettings.registrationQuestions
    },
    productQuestions: {
      ...newRegistrationSettings.productQuestions,
      ...existingRegistrationSettings.productQuestions
    }
  };
}

function mergeAppData(existingAppData = {}, newAppData) {
  const { registrationSettings = {}, registrationPathSettings = {} } = existingAppData;
  const { registrationSettings: newRegistrationSettings,
    registrationPathSettings: newRegistrationPathSettings } = newAppData;
  // Keep all reg paths and questions that have ever been seen so that things that have been filtered out because of a
  // reg path change don't disappear before we have a chance to switch to a page in the new reg path and so that the
  // reg paths used by other group/guest members are still available
  return {
    ...newAppData,
    registrationSettings: mergeRegistrationSettings(registrationSettings, newRegistrationSettings),
    registrationPathSettings: {
      ...registrationPathSettings,
      ...newRegistrationPathSettings
    }
  };
}

function roommateRequestSetupJsonPath(regPathId) {
  return `registrationSettings.registrationPaths.${regPathId}.travelSettings.hotelRequestSettings` +
    '.roommateRequestSettings';
}

function roommateRequestSetupRootJsonPath(regPathId) {
  return 'appData.' + roommateRequestSetupJsonPath(regPathId);
}

/**
 * action creator
 * @param mergedRoommateSettings
 * @returns {{payload: {mergedRoommateSettings: *}, type: string}}
 */
function createUpdateRoommateSettingsAction(mergedRoommateSettings) {
  return {
    type: UPDATE_ROOMMATE_SETTINGS,
    payload: { mergedRoommateSettings }
  };
}


/**
 * update app data for widgets that do not have roommate settings in appData
 * or do not have new roommate settings
 * @param configRoommateSetupSettings
 * @returns {Function}
 */
export function updateAppDataForRoommateSettings(configRoommateSetupSettings) {
  return (dispatch, getState) => {
    const regPathId = currentRegistrant.getRegistrationPathId(getState());
    const roommateRequestSettings = getJSONValue(getState(), roommateRequestSetupRootJsonPath(regPathId));
    const mergedRoommateSettings =
      getMergedRoommateSettings(configRoommateSetupSettings, roommateRequestSettings, {}, true);

    if (!!mergedRoommateSettings) {
      return dispatch(createUpdateRoommateSettingsAction(mergedRoommateSettings));
    }
  };
}

export default function appDataReducer(state = {}, action, rootState) {
  switch (action.type) {
    case LOAD_EVENT_SNAPSHOT:
      return mergeAppData(state, action.payload.appData);
    case UPDATE_ROOMMATE_SETTINGS: {
      const roommateSetupSettings = action.payload.mergedRoommateSettings || {};
      const regPathId = getRegistrationPathId(rootState);
      return setJSONValue(state, roommateRequestSetupJsonPath(regPathId), roommateSetupSettings);
    }
    default:
      return state;
  }
}
